import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import API_URL from '../constants/environment';
import { useContext } from 'react';
import SessionContext from '../contexts/SessionContext';
import { EnabledNotificationTypesDict } from './useGetProfile';

export interface UpdatedUserInfo {
    email?: string;
    firstName?: string;
    lastName?: string;
    username?: string;
    myLocations?: Array<string> | 'all';
    enabledNotificationTypes?: EnabledNotificationTypesDict;
    dailyEmailEnabled?: boolean;
    notificationsEnabled?: boolean;
}
const updateProfile = async (updatedUserInfo: UpdatedUserInfo, sessionId: string | null) => {
    return axios.post(`${API_URL}/profile/update`,
        updatedUserInfo,
        {
            headers: {
                Authorization: sessionId
            }
        }
    );
};

export const useUpdateProfile = () => {
    const sessionContext = useContext(SessionContext);
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (updatedUserInfo: UpdatedUserInfo) => updateProfile(updatedUserInfo, sessionContext?.sessionId ?? null),
        onSuccess: async () => {
            // Remove stale notification data from cache before invalidating
            // This ensures the unread count is recalculated with new enabledNotificationTypes
            await queryClient.resetQueries({ queryKey: ['/notifications'] });
            queryClient.invalidateQueries({ queryKey: ['profile'] });
            queryClient.invalidateQueries({ queryKey: ['/locations/find'] });
        }
    });
};
